'use client';

import { cn } from '@ncai-axe/react-ui-v3';
import styles from './styles.module.scss';

type FeatureCardProps = {
  id: string;
  title: string;
  description: string;
  onClick: (id: string) => void;
  icon?: React.ReactNode;
  disabled?: boolean;
  active?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

export function FeatureCard({
  id,
  title,
  description,
  onClick,
  icon,
  disabled = false,
  active = false,
  className,
  style,
}: FeatureCardProps) {
  const handleClick = () => {
    if (disabled) return;
    onClick(id);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className={cn(styles.card, className, {
        [styles.disabled]: disabled,
        [styles.active]: active,
      })}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      aria-pressed={active}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={style}
    >
      {icon && (
        <div className={styles.icon} aria-hidden="true">
          {icon}
        </div>
      )}
      <div className={styles.content}>
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
}
